const state = {
  observation: new Map(),
};

export default state;
